// extracted by mini-css-extract-plugin
module.exports = {"success_container":"register-success_success_container__1DY3V","success_box":"register-success_success_box___2AHN","success_icon":"register-success_success_icon__P_-Nc"};